import React from "react";
import {
  Container,
  Box,
  Typography,
  AppBar,
  Toolbar,
  Button,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { padding } from "@mui/system";

const Header = styled(AppBar)(({ theme }) => ({
  background: theme.palette.primary.main,
  position: "sticky",
  boxShadow: 3,
  borderBottom: `1px solid rgba(0,0,0, 0.1)`,
}));

const Footer = styled(Box)(({ theme }) => ({
  background: theme.palette.secondary.main,
  padding: theme.spacing(2),
  textAlign: "center",
}));

const Content = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "0px",
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <CssBaseline />
      {/* <Header>
        <Toolbar>
          <Container maxWidth="fixed" style={{ padding: "10px 0"}}>
            <Box
              className="displayStart headerlogo"
              variant="h6"
              color="inherit"
              style={{ flexGrow: 1, gap: "10px" }}
            >
              <img
                src="/images/logo.png"
                alt="healthcare_logo"
                onClick={() => navigate("/")}
                className="logoimageDash auth_logo"
                style={{ cursor: "pointer", height: "60px" }}
              />

              <Typography
                variant="h2"
                className="headerText"
                sx={{
                  fontWeight: 600,
                  textTransform: "uppercase",
                  fontSize: {
                    xs: "20px !important", // Mobile
                    sm: "24px", // Tablets
                    md: "28px", // Desktop
                  },
                }}
              >
                Santa Mario
              </Typography>
            </Box>
            <Button color="inherit">Login</Button>
          </Container>
        </Toolbar>
      </Header> */}
      <Content>
        <Container maxWidth="sm">{children}</Container>
      </Content>
      <Footer>
        <Typography variant="body2" color="textPrimary">
          © {new Date().getFullYear()} Doctor panel Developed By IRHIS - MVP
          overview
        </Typography>
      </Footer>
    </Box>
  );
};

export default AuthLayout;
